import { createFileRoute } from '@tanstack/react-router';
import { DemoPage } from '@/components/demo/DemoPage.tsx';
import { requireInternalOrganisation } from '@/lib/staffGate.ts';

/*
 * Not under /admin, but behind the same inner door: the Vue router marked this
 * route `requiresSuperadminInternal`, and wiping somebody's account is not a
 * thing a customer's own admin gets to do from here.
 */
export const Route = createFileRoute('/_app/demo')({
  staticData: { orgScope: 'none' },
  beforeLoad: ({ context }) => requireInternalOrganisation(context.queryClient),
  component: DemoPage,
});
